import { render, staticRenderFns } from "./packageDetail.vue?vue&type=template&id=10e23cd9&scoped=true"
import script from "./packageDetail.vue?vue&type=script&lang=js"
export * from "./packageDetail.vue?vue&type=script&lang=js"
import style0 from "./packageDetail.vue?vue&type=style&index=0&id=10e23cd9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e23cd9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10e23cd9')) {
      api.createRecord('10e23cd9', component.options)
    } else {
      api.reload('10e23cd9', component.options)
    }
    module.hot.accept("./packageDetail.vue?vue&type=template&id=10e23cd9&scoped=true", function () {
      api.rerender('10e23cd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/endCollectionMonitoring/component/packageDetail.vue"
export default component.exports